import DialogWrap from './DialogWrap';
export default DialogWrap;